// extracted by mini-css-extract-plugin
export default {"group":"_3GY5MtPl4r"};
    if(module.hot) {
      // 1633091727643
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  